import { ExpTempType } from "@/constants";
import { useCommonStore } from "@/stores";
import { TExpTemp } from "@/types";

const useExpTempList = () => {
  const isMobile = useCommonStore(state => state.isMobile);
  const activeExpTempIndex = useCommonStore(state => state.activeExpTempIndex);
  const activeExpTempType = useCommonStore(state => state.activeExpTempType);
  const activeExpTemp = useCommonStore(state => state.getters.activeExpTemp);
  const setActiveExpTempIndex = useCommonStore(state => state.setActiveExpTempIndex);
  const setActiveExpTempType = useCommonStore(state => state.setActiveExpTempType);
  const updatePlayState = useCommonStore(state => state.updatePlayState);
  const setIsPlayResult = useCommonStore(state => state.setIsPlayResult);

  const handleClickCommunityExpTemp = (index: number, item: TExpTemp) => {
    if (isMobile && activeExpTempType === ExpTempType.Community && activeExpTempIndex === index) {
      setIsPlayResult(false);
      updatePlayState(!activeExpTemp!.isPlay, item);
      return;
    }
    if (activeExpTempType !== ExpTempType.Community || activeExpTempIndex !== index) {
      setIsPlayResult(false);
      updatePlayState(true, item);
    }
    setActiveExpTempIndex(index);
    setActiveExpTempType(ExpTempType.Community);
  }
  
  const handleClickPresetExpTemp = (index: number, item: TExpTemp) => {
    if (isMobile && activeExpTempType === ExpTempType.Preset && activeExpTempIndex === index) {
      setIsPlayResult(false);
      updatePlayState(!activeExpTemp!.isPlay, item);
      return;
    }
    if (activeExpTempType !== ExpTempType.Preset || activeExpTempIndex !== index) {
      setIsPlayResult(false);
      updatePlayState(true, item);
    }
    setActiveExpTempIndex(index);
    setActiveExpTempType(ExpTempType.Preset);
  }

  const handleClickCusExpTemp = (index: number, item: TExpTemp) => {
    if (isMobile && activeExpTempType === ExpTempType.Cus && activeExpTempIndex === index) {
      setIsPlayResult(false);
      updatePlayState(!activeExpTemp!.isPlay, item);
      return;
    }
    if (activeExpTempType !== ExpTempType.Cus || activeExpTempIndex !== index) {
      setIsPlayResult(false);
      updatePlayState(true, item);
    }
    setActiveExpTempIndex(index);
    setActiveExpTempType(ExpTempType.Cus);
  }

  return {
    handleClickCommunityExpTemp,
    handleClickPresetExpTemp,
    handleClickCusExpTemp,
  }
}

export default useExpTempList;